import { ChecksumAlgorithm } from "./constants";
export var getChecksumLocationName = function (algorithm) {
    return algorithm === ChecksumAlgorithm.MD5 ? "content-md5" : "x-amz-checksum-" + algorithm.toLowerCase();
};
